// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3zS95","notes":"Notes_notes__2OV3i"};